// Motivational Quotes Service
// Fetches quotes from ZenQuotes API with static fallback

export interface Quote {
  text: string;
  author: string;
}

// ZenQuotes API endpoint
const ZENQUOTES_API_URL = 'https://zenquotes.io/api/random';

// Cache key and duration
const QUOTE_CACHE_KEY = 'motivational_quote_cache';
const QUOTE_CACHE_DURATION = 60 * 60 * 1000; // 1 hour

// Static fallback quotes
const FALLBACK_QUOTES: Quote[] = [
  { text: "The only way to do great work is to love what you do.", author: "Steve Jobs" },
  { text: "It does not matter how slowly you go as long as you do not stop.", author: "Confucius" },
  { text: "Success is not final, failure is not fatal: it is the courage to continue that counts.", author: "Winston Churchill" },
  { text: "The expert in anything was once a beginner.", author: "Helen Hayes" },
  { text: "Practice makes progress, not perfection.", author: "Unknown" },
  { text: "Every master was once a disaster.", author: "T. Harv Eker" },
  { text: "The beautiful thing about learning is that no one can take it away from you.", author: "B.B. King" },
  { text: "You don't have to be great to start, but you have to start to be great.", author: "Zig Ziglar" },
  { text: "A journey of a thousand miles begins with a single step.", author: "Lao Tzu" },
  { text: "Believe you can and you're halfway there.", author: "Theodore Roosevelt" },
  { text: "The more that you read, the more things you will know. The more that you learn, the more places you'll go.", author: "Dr. Seuss" },
  { text: "Education is the most powerful weapon which you can use to change the world.", author: "Nelson Mandela" },
  { text: "The capacity to learn is a gift; the ability to learn is a skill; the willingness to learn is a choice.", author: "Brian Herbert" },
  { text: "Learning never exhausts the mind.", author: "Leonardo da Vinci" },
  { text: "In learning you will teach, and in teaching you will learn.", author: "Phil Collins" },
  { text: "The only impossible journey is the one you never begin.", author: "Tony Robbins" },
  { text: "Your limitation—it's only your imagination.", author: "Unknown" },
  { text: "Push yourself, because no one else is going to do it for you.", author: "Unknown" },
  { text: "Great things never come from comfort zones.", author: "Unknown" },
  { text: "Dream it. Wish it. Do it.", author: "Unknown" },
  { text: "Success doesn't just find you. You have to go out and get it.", author: "Unknown" },
  { text: "The harder you work for something, the greater you'll feel when you achieve it.", author: "Unknown" },
  { text: "Don't stop when you're tired. Stop when you're done.", author: "Unknown" },
  { text: "Wake up with determination. Go to bed with satisfaction.", author: "Unknown" },
  { text: "Do something today that your future self will thank you for.", author: "Sean Patrick Flanery" },
  { text: "Little things make big days.", author: "Unknown" },
  { text: "It's going to be hard, but hard does not mean impossible.", author: "Unknown" },
  { text: "Don't wait for opportunity. Create it.", author: "Unknown" },
  { text: "Sometimes we're tested not to show our weaknesses, but to discover our strengths.", author: "Unknown" },
  { text: "The key to success is to focus on goals, not obstacles.", author: "Unknown" },
  { text: "Dream bigger. Do bigger.", author: "Unknown" },
  { text: "The secret of getting ahead is getting started.", author: "Mark Twain" },
  { text: "It always seems impossible until it's done.", author: "Nelson Mandela" },
  { text: "Quality is not an act, it is a habit.", author: "Aristotle" },
  { text: "The only person you are destined to become is the person you decide to be.", author: "Ralph Waldo Emerson" },
  { text: "Go confidently in the direction of your dreams.", author: "Henry David Thoreau" },
  { text: "When you feel like quitting, think about why you started.", author: "Unknown" },
  { text: "Don't let yesterday take up too much of today.", author: "Will Rogers" },
  { text: "You learn more from failure than from success.", author: "Unknown" },
  { text: "People who are crazy enough to think they can change the world are the ones who do.", author: "Rob Siltanen" },
  { text: "Knowing is not enough; we must apply. Willing is not enough; we must do.", author: "Johann Wolfgang von Goethe" },
  { text: "We may encounter many defeats but we must not be defeated.", author: "Maya Angelou" },
  { text: "Whether you think you can or think you can't, you're right.", author: "Henry Ford" },
  { text: "Creativity is intelligence having fun.", author: "Albert Einstein" },
  { text: "What you get by achieving your goals is not as important as what you become by achieving your goals.", author: "Zig Ziglar" },
  { text: "I have not failed. I've just found 10,000 ways that won't work.", author: "Thomas Edison" },
  { text: "A person who never made a mistake never tried anything new.", author: "Albert Einstein" },
  { text: "The mind is everything. What you think you become.", author: "Buddha" },
  { text: "Strive not to be a success, but rather to be of value.", author: "Albert Einstein" },
  { text: "Two roads diverged in a wood, and I—I took the one less traveled by, and that has made all the difference.", author: "Robert Frost" },
  { text: "The best time to plant a tree was 20 years ago. The second best time is now.", author: "Chinese Proverb" },
  { text: "Your time is limited, don't waste it living someone else's life.", author: "Steve Jobs" },
  { text: "Everything you've ever wanted is on the other side of fear.", author: "George Addair" },
  { text: "If you want to lift yourself up, lift up someone else.", author: "Booker T. Washington" },
  { text: "I find that the harder I work, the more luck I seem to have.", author: "Thomas Jefferson" },
  { text: "The future belongs to those who believe in the beauty of their dreams.", author: "Eleanor Roosevelt" },
  { text: "Start where you are. Use what you have. Do what you can.", author: "Arthur Ashe" },
  { text: "Don't be afraid to give up the good to go for the great.", author: "John D. Rockefeller" },
  { text: "If you are not willing to risk the usual, you will have to settle for the ordinary.", author: "Jim Rohn" },
  { text: "Try not to become a person of success, but rather try to become a person of value.", author: "Albert Einstein" },
  { text: "I am not a product of my circumstances. I am a product of my decisions.", author: "Stephen Covey" },
  { text: "Every strike brings me closer to the next home run.", author: "Babe Ruth" },
  { text: "Life is what happens to you while you're busy making other plans.", author: "John Lennon" },
  { text: "The only way to achieve the impossible is to believe it is possible.", author: "Charles Kingsleigh" },
  { text: "The purpose of our lives is to be happy.", author: "Dalai Lama" },
  { text: "You miss 100% of the shots you don't take.", author: "Wayne Gretzky" },
  { text: "If you want to achieve greatness stop asking for permission.", author: "Unknown" },
  { text: "The only thing standing between you and your goal is the story you keep telling yourself.", author: "Jordan Belfort" },
  { text: "Motivation is what gets you started. Habit is what keeps you going.", author: "Jim Ryun" },
  { text: "The only limit to our realization of tomorrow will be our doubts of today.", author: "Franklin D. Roosevelt" },
];

interface CachedQuote {
  quote: Quote;
  timestamp: number;
}

interface ZenQuoteResponse {
  q: string; // quote text
  a: string; // author
  h: string; // HTML formatted quote
}

/**
 * Get a random quote from the static fallback list
 */
const getRandomFallbackQuote = (): Quote => {
  const randomIndex = Math.floor(Math.random() * FALLBACK_QUOTES.length);
  return FALLBACK_QUOTES[randomIndex];
};

/**
 * Load cached quote from localStorage
 */
const getCachedQuote = (): Quote | null => {
  try {
    const cached = localStorage.getItem(QUOTE_CACHE_KEY);
    if (cached) {
      const parsedCache: CachedQuote = JSON.parse(cached);
      const now = Date.now();

      // Check if cache is still valid
      if (now - parsedCache.timestamp < QUOTE_CACHE_DURATION) {
        return parsedCache.quote;
      }
    }
  } catch (e) {
    console.log('Failed to load cached quote:', e);
  }
  return null;
};

/**
 * Save quote to localStorage cache
 */
const cacheQuote = (quote: Quote): void => {
  try {
    const cacheData: CachedQuote = {
      quote,
      timestamp: Date.now(),
    };
    localStorage.setItem(QUOTE_CACHE_KEY, JSON.stringify(cacheData));
  } catch (e) {
    console.log('Failed to cache quote:', e);
  }
};

/**
 * Fetch quote from ZenQuotes API
 */
const fetchFromApi = async (): Promise<Quote | null> => {
  try {
    const response = await fetch(ZENQUOTES_API_URL, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`API responded with status: ${response.status}`);
    }

    const data: ZenQuoteResponse[] = await response.json();

    if (data && data.length > 0) {
      return {
        text: data[0].q,
        author: data[0].a,
      };
    }

    return null;
  } catch (e) {
    console.log('Failed to fetch quote from ZenQuotes:', e);
    return null;
  }
};

/**
 * Get a motivational quote
 * 1. Check cache first
 * 2. Try ZenQuotes API
 * 3. Fall back to static quotes
 */
export const getMotivationalQuote = async (forceRefresh: boolean = false): Promise<Quote> => {
  // Check cache first (unless force refresh)
  if (!forceRefresh) {
    const cachedQuote = getCachedQuote();
    if (cachedQuote) {
      return cachedQuote;
    }
  }

  // Try to fetch from API
  const apiQuote = await fetchFromApi();

  if (apiQuote) {
    cacheQuote(apiQuote);
    return apiQuote;
  }

  // Fall back to static quotes
  const fallbackQuote = getRandomFallbackQuote();
  cacheQuote(fallbackQuote);
  return fallbackQuote;
};

/**
 * Clear the cached quote (useful for testing or forcing refresh)
 */
export const clearQuoteCache = (): void => {
  try {
    localStorage.removeItem(QUOTE_CACHE_KEY);
  } catch (e) {
    console.log('Failed to clear quote cache:', e);
  }
};
